<template>
<span class="value-valid-email" :class="classes">{{value}}</span>
</template>
<script>
export default {
  props: ['item', 'column', 'model'],
  computed: {
    value(){
      return eval('this.item.' + this.column.name)
    },
    classes(){
      if(this.isValid()){
        return 'is-valid'
      }else{
        return 'is-not-valid'
      }
    }
  },
  methods: {
    isValid(){
      if(this.item.has_valid_email){
        return true 
      }else if(typeof this.item.has_valid_email == 'undefined'){
        return true 
      }
      return false
    }
  }
}
</script>



// WEBPACK FOOTER //
// CollectionValueValidEmail.vue?42745b7f